import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { useState } from 'react';
import { SelectControlProps } from './types';

const SelectControl: React.FC<SelectControlProps> = (props) => {
    const [item, setItem] = useState(props.default);
    const emptyValue = 'none';

    const handleFieldChange = (event: SelectChangeEvent) => {
        const value = event.target.value;

        if (props.isArray) {
            if (item !== emptyValue && value === emptyValue)
                props.setComponentData({
                    ...props.componentData,
                    [props.fieldName]: props.componentData?.[props.fieldName]?.filter((x: string) => x !== item),
                });
            else if (item !== emptyValue && value !== emptyValue)
                props.setComponentData({
                    ...props.componentData,
                    [props.fieldName]: props.componentData?.[props.fieldName]?.map((x: string) => {
                        return x !== item ? x : value;
                    }),
                });
            else
                props.setComponentData({
                    ...props.componentData,
                    [props.fieldName]: props.componentData?.[props.fieldName]
                        ? [...props.componentData?.[props.fieldName], value]
                        : [value],
                });
        } else props.setComponentData({ ...props.componentData, [props.fieldName]: value === emptyValue ? '' : value });

        setItem(value);
    };

    return (
        <FormControl>
            <InputLabel id={`${props.fieldName}_${props.index}`}>{props.label}</InputLabel>
            <Select
                sx={{ minWidth: props.minWidth || 'auto' }}
                labelId={`${props.fieldName}_${props.index}`}
                id={`${props.fieldName}_${props.index}`}
                value={item}
                label={props.label}
                onChange={handleFieldChange}
            >
                {props.selectData
                    .filter(
                        (x) =>
                            !props.singleChoice ||
                            !(props.componentData && props.componentData[props.fieldName]?.includes(x.value)) ||
                            x.value === item,
                    )
                    .map((item, index) => {
                        return (
                            <MenuItem key={index} value={item.value}>
                                {props.language ? (item.label as Record<string, string>)?.[props.language] : item.label}
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
};

export default SelectControl;
